// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}





.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.lds-default,
.lds-default div {
  box-sizing: border-box;
}
.lds-default {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-default div {
  position: absolute;
  width: 6.4px;
  height: 6.4px;
  background: currentColor;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}
.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 36.8px;
  left: 66.24px;
}
.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22.08px;
  left: 62.29579px;
}
.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11.30421px;
  left: 51.52px;
}
.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7.36px;
  left: 36.8px;
}
.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11.30421px;
  left: 22.08px;
}
.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22.08px;
  left: 11.30421px;
}
.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 36.8px;
  left: 7.36px;
}
.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 51.52px;
  left: 11.30421px;
}
.lds-default div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62.29579px;
  left: 22.08px;
}
.lds-default div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66.24px;
  left: 36.8px;
}
.lds-default div:nth-child(11) {
  animation-delay: -1s;
  top: 62.29579px;
  left: 51.52px;
}
.lds-default div:nth-child(12) {
  animation-delay: -1.1s;
  top: 51.52px;
  left: 62.29579px;
}
@keyframes lds-default {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}

iframe[title="reCAPTCHA"] {
    display: none !important;
    visibility: hidden !important;
    width: 0 !important;
    height: 0 !important;
    position: absolute !important;
    left: -9999px !important;
}
.grecaptcha-badge {
    display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;;;;;AAMA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;IAC7B,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n\n\n\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.lds-default,\n.lds-default div {\n  box-sizing: border-box;\n}\n.lds-default {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.lds-default div {\n  position: absolute;\n  width: 6.4px;\n  height: 6.4px;\n  background: currentColor;\n  border-radius: 50%;\n  animation: lds-default 1.2s linear infinite;\n}\n.lds-default div:nth-child(1) {\n  animation-delay: 0s;\n  top: 36.8px;\n  left: 66.24px;\n}\n.lds-default div:nth-child(2) {\n  animation-delay: -0.1s;\n  top: 22.08px;\n  left: 62.29579px;\n}\n.lds-default div:nth-child(3) {\n  animation-delay: -0.2s;\n  top: 11.30421px;\n  left: 51.52px;\n}\n.lds-default div:nth-child(4) {\n  animation-delay: -0.3s;\n  top: 7.36px;\n  left: 36.8px;\n}\n.lds-default div:nth-child(5) {\n  animation-delay: -0.4s;\n  top: 11.30421px;\n  left: 22.08px;\n}\n.lds-default div:nth-child(6) {\n  animation-delay: -0.5s;\n  top: 22.08px;\n  left: 11.30421px;\n}\n.lds-default div:nth-child(7) {\n  animation-delay: -0.6s;\n  top: 36.8px;\n  left: 7.36px;\n}\n.lds-default div:nth-child(8) {\n  animation-delay: -0.7s;\n  top: 51.52px;\n  left: 11.30421px;\n}\n.lds-default div:nth-child(9) {\n  animation-delay: -0.8s;\n  top: 62.29579px;\n  left: 22.08px;\n}\n.lds-default div:nth-child(10) {\n  animation-delay: -0.9s;\n  top: 66.24px;\n  left: 36.8px;\n}\n.lds-default div:nth-child(11) {\n  animation-delay: -1s;\n  top: 62.29579px;\n  left: 51.52px;\n}\n.lds-default div:nth-child(12) {\n  animation-delay: -1.1s;\n  top: 51.52px;\n  left: 62.29579px;\n}\n@keyframes lds-default {\n  0%, 20%, 80%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.5);\n  }\n}\n\niframe[title=\"reCAPTCHA\"] {\n    display: none !important;\n    visibility: hidden !important;\n    width: 0 !important;\n    height: 0 !important;\n    position: absolute !important;\n    left: -9999px !important;\n}\n.grecaptcha-badge {\n    display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
